import React from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
// import ReactDataGridPlugins from 'react-data-grid/addons';

export default class FilesetPreviewTable extends React.Component {
  static propTypes = {
    filesetPreview: PropTypes.object.isRequired,
  };

  state = {
    rows: [],
    columns: [],
  };

  componentWillMount = () => {
    const { filesetPreview } = this.props;
    const { columns } = this.state;
    this.renderColumns(filesetPreview.get('fields'));
    this.renderRows(columns, filesetPreview.get('records'));
  };

  verifyAndUpdateDataTypes = data => {
    const _data = {};
    Object.keys(data).forEach(d => {
      if (typeof data[d] === 'boolean') {
        _data[d] = data[d].toString();
      } else {
        _data[d] = data[d];
      }
    });
    return _data;
  };

  rowGetter = i => {
    const { rows } = this.state;
    return rows[i];
  };

  renderColumns = filesetFields => {
    const _columns = [];
    filesetFields.map(field => {
      _columns.push({
        key: field.name,
        name: field.description ? field.description : field.name,
        resizable: true,
        width: 150,
      });
      return _columns;
    });
    return this.setState({ columns: _columns });
  };

  renderRows = (columns, filesetRecords) => {
    const _rows = [];
    filesetRecords.map(record => {
      const data = this.verifyAndUpdateDataTypes(record.data);
      _rows.push(data);
      return _rows;
    });
    return this.setState({ rows: _rows });
  };

  render() {
    const { columns, rows } = this.state;
    const { filesetPreview } = this.props;
    return filesetPreview.get('records').length === 0 ||
      filesetPreview.get('records') === undefined ? (
      <p>This fileset has no data</p>
    ) : (
      <ReactDataGrid
        columns={columns}
        rowGetter={this.rowGetter}
        rowsCount={rows.length}
        minHeight={500}
      />
    );
  }
}
